export function NewEliteDashboardHeadCardSkeleton() {
  return (
    <div className='my-10'>
      <div className='overflow-hidden rounded-2xl bg-white animate-pulse'>
        <div className='flex items-start justify-between gap-3 px-5 py-4'>
          <div className='space-y-2'>
            <div className='h-[14px] w-24 rounded bg-[#E9E3E1]' />
            <div className='h-[13px] w-36 rounded bg-[#F2ECEA]' />
          </div>
          <div className='space-y-2 text-right'>
            <div className='ml-auto h-[14px] w-20 rounded bg-[#E9E3E1]' />
            <div className='ml-auto h-[13px] w-16 rounded bg-[#F2ECEA]' />
          </div>
        </div>
      </div>
    </div>
  )
}
